module.exports = __webpack_public_path__ + "static/img/01bg1.0b55f52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/report/03month/01bg1.png
// module id = lOgU
// module chunks = 0